export default __webpack_public_path__ + "static/media/igloo-hover.2f6b0790.png";